import { Suspense, lazy } from "react";

import { useDevMode } from "@citrine/client";

const LazyDevtools = lazy(() =>
  import("./dev-tools")
    // if the import fails, return a non-resolving Promise to ignore the failure
    // and prevent crashing
    .catch(() => new Promise(() => {})),
);

export function DevTools() {
  const [isDevMode] = useDevMode();

  return isDevMode ? (
    <Suspense fallback={null}>
      <LazyDevtools />
    </Suspense>
  ) : null;
}
